import { WebsiteOrSocialMediaInput, WebsiteTypeEnum } from '~/bff/graphql/generated/graphql'

const getObj = (type: WebsiteTypeEnum, link: string) => {
  switch (type) {
    case WebsiteTypeEnum.Linkedin:
      return { link, text: 'LinkedIn', icon: 'fa-brands fa-linkedin' }
    case WebsiteTypeEnum.Facebook:
      return { link, text: 'Facebook', icon: 'fa-brands fa-facebook' }
    case WebsiteTypeEnum.Twitter:
      return { link, text: 'X', icon: 'fa-brands fa-x-twitter' }
    case WebsiteTypeEnum.Github:
      return { link, text: 'Github', icon: 'fa-brands fa-github' }
    case WebsiteTypeEnum.Tiktok:
      return { link, text: 'TikTok', icon: 'fa-brands fa-tiktok' }
    case WebsiteTypeEnum.Instagram:
      return { link, text: 'Instagram', icon: 'fa-brands fa-instagram' }
    case WebsiteTypeEnum.Personal_1:
      return { link, text: 'Website', icon: 'fa-solid fa-globe' }
    case WebsiteTypeEnum.Personal_2:
      return { link, text: 'Website', icon: 'fa-solid fa-globe' }
    default: {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const _exhaustiveCheck: never = type
      return null
    }
  }
}

const order = [
  WebsiteTypeEnum.Linkedin,
  WebsiteTypeEnum.Facebook,
  WebsiteTypeEnum.Twitter,
  WebsiteTypeEnum.Github,
  WebsiteTypeEnum.Tiktok,
  WebsiteTypeEnum.Instagram,
  WebsiteTypeEnum.Personal_1,
  WebsiteTypeEnum.Personal_2,
]

export const mapSocialLinksToNameAndIcon = (links: WebsiteOrSocialMediaInput[] = []) => {
  const result: Array<{ link: string; text: string; icon: string }> = []
  order.forEach((type) => {
    const link = links.find((link) => link.type === type)
    if (!link) {
      return
    }

    const { websiteURL, type: linkType } = link
    if (!websiteURL) {
      return
    }

    const obj = getObj(linkType, websiteURL)
    if (!obj) {
      return
    }

    result.push(obj)
  })

  return result
}
